import { render, staticRenderFns } from "./ClassEES7Emoji.vue?vue&type=template&id=52e936ca&"
import script from "./ClassEES7Emoji.vue?vue&type=script&lang=ts&"
export * from "./ClassEES7Emoji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports